// extracted by mini-css-extract-plugin
export var settingsList = "_31-0";
export var settingsRow = "_31-1";
export var warningDot = "_31-2";